
import $ from 'jquery';
import Vue from 'vue';
import { VueGoodTable } from 'vue-good-table'; // see https://github.com/xaksis/vue-good-table
import 'vue-good-table/dist/vue-good-table.css';
import { Component, Prop } from 'vue-property-decorator';
import { formatDateTime } from '../../util';
import { BasePoI, TypePOI } from '../backend/backendapi';

@Component({
  name: 'PoiListModal',
  components: {
    VueGoodTable,
  },
})
export default class PoiListModal extends Vue {
  @Prop({ required: true })
  readonly pois!: BasePoI[];

  get columnsConfig() {
    return [
      {
        label: this.$i18n.t('txtLastChecked').toString(),
        field: (e: BasePoI) => e.lastChecked ? formatDateTime(e.lastChecked) : '',
      },
      {
        label: this.$i18n.t('txtType').toString(),
        field: (e: BasePoI) => this.formatType(e.type),
      },
      {
        label: this.$i18n.t('txtName').toString(),
        field: 'name',
      },
    ];
  }

  public open(): void {
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  //event handler
  onRowClick(params: { row: BasePoI, pageIndex: number, selected: boolean, event: MouseEvent }): void {
    console.log(params);
    this.dismiss();
    this.$emit('selectedPoi', params.row);
  }

  //mapper
  private formatType(value): string {
    //console.log("date=" + value);
    if (!value) {
      return 'NA';
    }
    switch (value) {
      case TypePOI.Waterpoint:
        return 'W';
      case TypePOI.FireAlarmSystem:
        return 'F';
      case TypePOI.Resource:
        return 'R';
      case TypePOI.ObjectPlan:
        return 'O';
      case TypePOI.User:
        return 'U';
      default:
        return 'not defined';
    }
  }
}
